// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1443":"3823c50d62b9ec91","4667":"4eccb67a5be3792f","5058":"29e3e7d259c59aab","7551":"27379fd0c7387dbb"}[chunkId] + ".css";
};